import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(requestBody: Request): Promise<Optional<string>> {
	const url: string = `${SERVICEBASEURL.USER}/User/Create`;
	return axios.post(url, requestBody).toOptionalMapped((x) => x.data);
}

export interface Request {
	user: RequestUser;
	confirmationPageUrl: string;
}

export interface Response {
	data: string;
}

export type RequestUser = {
	firstName: string;
	lastName: string;
	email: string;
	languageId: string;
	profilePictureId?: string;
	userSettings: UserSettingsApi | null;
	roles: string[];
	isActive: boolean;
};

export type UserSettingsApi = {
	'Price.Currency'?: string;
	'Recipe.List.ValueScope': ValueScope;
	'Preferred.Nutrient.Ids'?: string;
};

export enum ValueScope {
	Total = 'Total',
	Person = 'Person',
	Parts = 'Parts',
	HundredGrams = 'HundredGrams',
}
